import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import IndividualProjectsApi from '../generated/api/IndividualProjects';

export default (service: Servicelayer) => ({
  ...IndividualProjectsApi(service),

  // Add custom calls here

});
